<template>
    <gCartList
        v-if="list.length"
        :class="['is-'+ type]"
    >
        <gCartListHeader>
            <mdCartCaption
                :caption="$t('page.shoppingcart.caption.'+ type)"
            ></mdCartCaption>
        </gCartListHeader>
        <gCartListContent>
            <gCartInfoSection>
                <div class="md list">
                    <div
                        v-if="type !== 'unmarket' && cartList.length > 2"
                        class="group"
                    >
                        <input type="checkbox" id="all" class="checkbox" :checked="cartList[0].check" @change="tagChange(cartList[0].sn, cartList[0].check)">
                        <label for="all">{{ $t('page.shoppingcart.func.selectall')}}</label>
                    </div>
                    <div class="group">
                        <ul>
                            <template v-for="item in cartList">
                                <li
                                    v-if="item.content"
                                    :key="item.sn"
                                >    
                                    <mdCartInfo
                                        :node="item.content"
                                        :setPrice="priceList[item.sn]"
                                        :editable="type === 'hasprice' || type === 'noprice'? 'all': 'none'"
                                        :deletable="true"
                                        :ref="'mdCartInfo-'+ item.sn"
                                        :check="item.check"
                                        :sn="item.sn"
                                        :canCheck="true"
                                        @sendEvent="receiveEvent"
                                    ></mdCartInfo>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <mdEditorForPrice
                    v-if="type === 'hasprice'"
                    :caption="$t('page.shoppingcart.func.ordertotal')"
                    :sub="isTax ? $t('page.shoppingcart.func.tax'): ''"
                    :price="$okaTool.numberToStringFormat(info.aftertax)"
                >
                    <span
                        v-if="codiv != '11'"
                        class="extend"
                        @click="showPopUp($event, $t('cartList.alert'))"
                        @mouseenter="showToolTip($event, $t('cartList.alert'))"
                    ></span>
                </mdEditorForPrice>
                <mdInfoCard :caption="$t('page.shoppingcart.caption.ordersummary')">
                    <div
                        slot="top"
                        class="func"
                    >
                        <a class="is-font is-save" v-if="editData" @click.prevent="saveClient">{{ $t('cartList.saveClient') }}</a>
                        <a class="is-font is-edit" v-else @click.prevent="editClient">{{ $t('cartList.editClient') }}</a>
                    </div>
                    <ul slot="list">
                        <li v-if="checkFilter.length">
                            <div class="key">{{ $t('page.shoppingcart.func.ordertotalqty') }}</div>
                            <div class="value">{{ checkFilter.length }}</div>
                        </li>
                        <li v-if="info.original">
                            <div class="key">{{ $t('page.shoppingcart.func.original') }}</div>
                            <div class="value">{{ this.$okaTool.numberToStringFormat(info.original) }}</div>
                        </li>
                        <li v-if="allowancePrice">
                            <div class="key">{{ $t('page.shoppingcart.func.discount') }}</div>
                            <div class="value">{{ this.$okaTool.numberToStringFormat(allowancePrice) }}</div>
                        </li>
                        <li v-if="isTax && info.tax">
                            <div class="key">{{ $t('page.shoppingcart.func.taxCaption') }}</div>
                            <div class="value">{{ this.$okaTool.numberToStringFormat(info.tax) }}</div>
                        </li>
                        <li v-if="creditBalance !== null">
                            <div class="key">{{ $t('site.noun.creditbalance') }}</div>
                            <div
                                class="value"
                                :class="[creditBalance > 0? '': 'is-danger']"
                            >{{ this.$okaTool.numberToStringFormat(creditBalance) }}</div>
                        </li>
                        <template v-if="discountCuno">
                            <li
                                class="is-block"
                                v-for="(item, key) in allowanceBar"
                                :key="key"
                            >
                                <div class="key">
                                    {{ key }}
                                    {{ $t('page.shoppingcart.discont.current.discount') }}:
                                    <span class="color is-danger">{{ item.range[item.current].discount }}</span>
                                    {{ $t('page.shoppingcart.discont.current.range') }}:
                                    <span class="color is-danger">{{ item.range[item.current].qty }}</span>
                                    {{ $t('page.shoppingcart.discont.total.qty') }}:
                                    <span class="color is-danger">{{ item.total }}</span>
                                </div>
                                <cpRate
                                    :range="item.range"
                                    :current="item.current"
                                    v-model="item.value"
                                ></cpRate>
                                <div class="key">{{ $t('page.shoppingcart.discont.explane', {
                                    qty: item.range[item.value].qty,
                                    discount: item.range[item.value].discount,
                                }) }}</div>
                            </li>
                        </template>
                        <li v-if="editData || (!editData && client.cuodno)">
                            <div class="key">{{ $t('popup.dropshipping.caption.customerorder') }}</div>
                            <div
                                v-if="editData"
                                class="value"
                            >
                                <div class="cp input text" :class="[errors.has('cuodno')? 'is-error': '']" :data-error="errors.first('cuodno')">
                                    <input type="text" v-model="client.cuodno" v-validate="'max:25'" name="cuodno" id="cuodno" />
                                </div>
                            </div>
                            <div
                                v-else
                                class="value"
                            >{{ client.cuodno }}</div>
                        </li>
                        <template v-if="division == 'TRL'">
                            <li class="is-block">
                                <div class="key">{{ $t('popup.dropshipping.caption.customeradd') }}</div>
                                <div
                                    v-if="editData"
                                    class="value"
                                >
                                    <div class="cp input select">
                                        <select v-model="clientData" name="clientData" @change="changeClientBySelect">
                                            <option value="">{{ user.dlsite }}</option>
                                            <option v-for="item in adcunoAddress" :key="item.adcuno +'@'+ item.cufn +'@'+ item.dlsite" :value="item.adcuno +'@'+ item.cufn +'@'+ item.dlsite">{{ item.dlsite }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div
                                    v-else
                                    class="value"
                                >{{ client.dlsite || user.dlsite }}</div>
                            </li>
                        </template>
                        <template v-else>
                            <li v-if="editData || (!editData && client.adcuno && client.cufn)">
                                <div class="key">{{ $t('popup.dropshipping.caption.recipient') }}</div>
                                <div
                                    v-if="editData"
                                    class="value"
                                >
                                    <div class="cp input select">
                                        <select v-model="clientData" name="clientData" @change="changeClientBySelect">
                                            <option value="">{{ $t('site.select.default') }}</option>
                                            <option v-for="item in adcunoAddress" :key="item.adcuno +'@'+ item.cufn +'@'+ item.dlsite" :value="item.adcuno +'@'+ item.cufn +'@'+ item.dlsite">{{ item.adcuno +' / '+ item.cufn }}</option>
                                            <option value="/">新增</option>
                                        </select>
                                    </div>
                                    <!-- 20230209_PP要求改成AutoComplete -->
                                    <!-- <cpAutocomplete
                                        :options="adcunoAddress.map(item => item.adcuno +' / '+ item.cufn )"
                                        v-validate="'included:'+ adcunoAddress.map(item => item.adcuno +' / '+ item.cufn ).join(',')"
                                        v-model="clientData"
                                        :errorStatus="errors.has('clientData')"
                                        :errorMsg="errors.first('clientData')"
                                        name="clientData"
                                        :hideLabel="true"
                                        @input="changeClientByAutocomplete"
                                    ></cpAutocomplete> -->
                                </div>
                                <div
                                    v-else
                                    class="value"
                                >{{ client.adcuno +' / '+ client.cufn }}</div>
                            </li>
                            <li class="is-block">
                                <div class="key">{{ $t('popup.dropshipping.caption.customeradd') }}</div>
                                <div class="value">{{ client.dlsite || user.dlsite }}</div>
                            </li>
                        </template>
                        <template v-if="division == 'PVC'">
                            <li>
                                <div class="key">{{ $t('page.shoppingcart.caption.pickup') }}</div>
                                <div
                                    v-if="editData"
                                    class="value"
                                >   
                                    <input class="slidecheck" type="checkbox" v-model="client.iscustomerpickup" name="iscustomerpickup" id="iscustomerpickup" /><label for="iscustomerpickup"></label>
                                </div>
                                <div
                                    v-else
                                    class="value"
                                >{{ client.iscustomerpickup? $t('page.shoppingcart.caption.yes'): $t('page.shoppingcart.caption.no') }}</div>
                            </li>
                            <li>
                                <div class="key">{{ $t('page.shoppingcart.caption.deliverycontact') }}</div>
                                <div
                                    v-if="editData"
                                    class="value"
                                >   
                                    <input class="slidecheck" type="checkbox" v-model="client.isactualdelivery" name="isactualdelivery" id="isactualdelivery" /><label for="isactualdelivery"></label>
                                </div>
                                <div
                                    v-else
                                    class="value"
                                >{{ client.isactualdelivery? $t('page.shoppingcart.caption.yes'): $t('page.shoppingcart.caption.no') }}</div>
                            </li>
                        </template>
                        <li :class="[editData? 'is-input': 'is-block']">
                            <div class="key">
                                {{ $t('page.shoppingcart.caption.remarks') }}
                                <cpLabel
                                    :themes="remarkwordsLength > remarkwordsMax? 'danger': 'info'"
                                    :text="this.$t('remarks.wordsMax', { max: remarkwordsMax, length: remarkwordsLength })"
                                ></cpLabel>
                            </div>
                            <div
                                v-if="editData"
                                class="value"
                            >
                                <div class="cp input textarea" :class="[errors.has('remark')? 'is-error': '']" :data-error="errors.first('remark')">
                                    <textarea v-model="client.remark" v-validate="'max_bytes:'+ remarkwordsMax" name="remark" id="remark"></textarea>
                                </div>
                            </div>
                            <div
                                v-else
                                class="value"
                            >{{ client.remark }}</div>
                            <!-- <pre>{{ allowanceType }}</pre> -->
                        </li>
                    </ul>
                </mdInfoCard>
                <mdBtnList
                    :disabled="!list.length"
                    :content="btns"

                    @sendEvent="receiveEvent"
                ></mdBtnList>
            </gCartInfoSection>
        </gCartListContent>
    </gCartList>
</template>

<script>
    import mdCartCaption from '@/components/mdCartCaption'
    import mdCartInfo from '@/components/mdCartInfo'
    import mdInfoCard from '@/components/mdInfoCard'
    import mdBtnList from '@/components/mdBtnList'
    import mdEditorForPrice from '@/components/mdEditorForPrice'
    import gCartList from '@/components/gCartList'
    import gCartListHeader from '@/components/gCartListHeader'
    import gCartListContent from '@/components/gCartListContent'
    import gCartInfoAside from '@/components/gCartInfoAside'
    import gCartInfoSection from '@/components/gCartInfoSection'
    import cpAutocomplete from '@/components/cpAutocomplete'
    import cpStatus from '@/components/cpStatus'
    import cpLabel from '@/components/cpLabel'
    import cpRate from '@/components/cpRate'
    import VueCookie from 'vue-cookie'

    import { Decimal } from 'decimal.js';
    import { mapGetters, mapMutations , mapState } from 'vuex'

    let $defaultClient = {
            cuodno: '',
            adcuno: '',
            cufn: '',
            dlsite: '',
            remark: '',
        }

    export default {
        components: {
            mdCartCaption,
            mdCartInfo, 
            mdInfoCard,
            mdBtnList,
            mdEditorForPrice,
            gCartList,
            gCartListHeader,
            gCartListContent,
            gCartInfoAside,
            gCartInfoSection,
            cpStatus,
            cpLabel,
            cpRate,
            cpAutocomplete
        },
        props: {
            list: {
                type: Array,
                required: false,
                default: function(){
                    return []
                }
            },
            type: {
                type: String,
                required: false,
                default: 'hasprice'
            },
        },
        data: function(){

            return {
                priceList: {}, //提供購物車品項價格對照
                dateList: {}, //提供購物車品項日期對照
                client: $defaultClient,
                cartList: [],
                checkAll: false,
                editData: false,
                adcunoAddress: [],
                remarkwordsMax: 30,
                clientData: '',
                discountData: [],
                range1: 0,
                range2: 0,
                allowanceBar: {}
            }
        },
        watch: {
            list: {
                handler: function(){
                    this.initCart();
                    this.initList();
                },
            },
            checkMonth: {
                handler: function(){
                    this.initDiscount();
                },
            },
            allowanceType: {
                handler: function(){
                    this.initAllowanceBar();
                },
                deep: true,
            },
            unDiscountCuno: {
                handler: function(){
                    this.initAllowanceBar();
                },
                deep: true,
            }
        },
        computed: {
             ...mapState([
                'shoppingCart',
                'productList',
                'priceObject',
                'user',
                'creditBalance',
                'unDiscountCuno',
            ]),
            ...mapGetters([
                'division'
            ]),
            codiv: function(){
                let $user = this.user;

                return $user.co +''+ $user.div;
            },
            discountCuno: function(){
                return !this.unDiscountCuno.includes(this.user.cuno);
            },
            allowanceTable: function(){

                if( this.discountCuno ) {
                    return this.$siteConfig.allowanceTable || {}
                }else {
                    return {}
                }
            },
            allowancePrice: function(){
                let $allowanceType = this.allowanceType,
                    $total = $allowanceType.total, //{ 'PE': 1008000.1 }
                    $single = $allowanceType.single, //{ 'PE': 1008000.1 }
                    $allowance = {} //{ 'PE': -0.65 }

                let $allowanceTable = this.allowanceTable || {},
                    $divTable = $allowanceTable[this.codiv] || {},
                    $typeList = Object.keys($divTable); //['PE', 'EVA']

                let _result = new Decimal(0); //總折扣讓

                $typeList.forEach(type => { //PE、EVA
                    let _single = $single[type] || 0;

                    if( _single ) {
                        let _total = $total[type] || 0,
                            _prevTotal = _total - _single; //qty

                        let _allowancePrice = new Decimal(0); //該大類的折扣讓

                        if( $total[type] ) { //如果該中類有折扣讓規則
                            let $type = $divTable[type] || {},
                                $levelList = Object.keys($type); //[15000, 30000...]

                            $levelList = $levelList.map(item => parseInt(item, 10));

                            $levelList.sort((a, b) => a < b? 1: -1); //[200000, 100000...]
                            
                            let _prevLevel = $levelList.find(level => level <= _prevTotal) || 0,
                                _thisLevel = $levelList.find(level => level <= _total) || 0;

                            _allowancePrice = _allowancePrice.add(new Decimal($type[_thisLevel]).mul(new Decimal(_total))); //目前總的 total
                            _allowancePrice = _allowancePrice.sub(new Decimal($type[_prevLevel]).mul(new Decimal(_prevTotal))); //減掉上次總的 total
                        }

                        $allowance[type] = _allowancePrice; //-32000
                    }
                });

                for( let _type in $allowance ) {
                    _result = _result.add($allowance[_type]);
                }

                return parseFloat(_result.toFixed(2), 10);
            },
            allowanceType: function(){
                let $result = {
                        single: {},
                        total: {},
                    },
                    $_updateResult = (obj, type, qty) => {
                        let _qty = 0;

                        if( parseFloat(qty, 10) == qty ) {
                            _qty = qty;
                        }

                        _qty = new Decimal(_qty);

                        if( obj[type] ) {
                            obj[type] = obj[type].add(_qty);
                        }else {
                            obj[type] = _qty;
                        }
                    }

                if( this.codiv == 18 ) {
                    this.checkFilter.forEach(item => {
                        let $content = item.content,
                            _product_b = $content.product_b || '';

                        let _type = '';

                        _product_b = _product_b.toUpperCase();

                        if( _product_b === 'EVA' ) {
                            _type = 'EVA';
                        }else {
                            _type = 'PE';
                        }
                        
                        $_updateResult($result.single, _type, $content.qty);
                        $_updateResult($result.total, _type, $content.qty);
                    });
                    
                    this.discountData.forEach(item => {
                        $_updateResult($result.total, item.classify, item.aoqty);
                    });
                }

                for( let _t in $result ) {

                    for( let _b in $result[_t] ) {
                        $result[_t][_b] = parseFloat($result[_t][_b].toFixed(2), 10);
                    }
                }

                // {
                //     single: {
                //         PE: 1008000.1,
                //     },
                //     total: {
                //         PE: 1008000.1,
                //     }
                // }

                return $result;
            },
            remarkwordsLength: function(){ //備註的字數
                let $client = this.client,
                    _remark = $client.remark || '',
                    _length = encodeURI(_remark).split(/%..|./).length - 1;

                return _length;
            },
            isTax: function(){ //是否有5%營業稅
                let $user = this.user

                //https://www.notion.so/84092b92b33d47bd99f34da8b905b7a1
                if($user.cukd === 'E' || $user.cukd === 'B'){
                    return false;
                }else {
                    return true;
                }
            },
            checkFilter: function() { //勾選項目
                return this.cartList.filter(item => item.check && item.content);
            },
            checkMonth: function(){
                let $dateList = this.dateList,
                    $checkFilter = this.checkFilter,
                    _length = $checkFilter.length;

                let _month = '',
                    _every = false;

                if( _length ) {
                    let $item = $checkFilter[0],
                        _date = $dateList[$item.sn]

                    if( _date ) {
                        _month = _date.replace(/\-\d\d$/, ''); //2022-12
                    }
                }

                if( _month ) {
                    _every = $checkFilter.every(item => $dateList[item.sn].includes(_month))
                }

                if( _every && _month ) {
                    return _month;
                }else {
                    return '';
                }
            },
            hasClient: function(){
                let $client = this.client,
                    _hasClient = false;

                for(var item in $client){
                    if($client[item] && item !== 'dlsite'){
                        _hasClient = true
                        break;
                    }
                }
             
                return _hasClient;
            },
            info: function(){
                let $aftertax = new Decimal(0),
                    $tax = new Decimal(0),
                    $allowancePrice = new Decimal(this.allowancePrice),
                    $list = this.priceList,
                    $original = new Decimal(0);

                this.checkFilter.forEach(item => {
                    let $content = item.content,
                        _cart_sn = $content.cart_sn;

                    let _contentQty = 0;
                    
                    if( parseFloat($content.qty, 10) == $content.qty ) {
                        _contentQty = $content.qty
                    }

                    let _qty = new Decimal(_contentQty),
                        _price = $list[_cart_sn]

                    if(typeof _price === 'number') {
                        $original = $original.add(_qty.mul(new Decimal(_price)));
                    }
                });

                let $beforetax = $original.add($allowancePrice);
                
                if( this.isTax ){
                    $aftertax = $beforetax.mul(new Decimal(1.05));
                    $tax = $beforetax.mul(new Decimal(0.05));
                }else{
                    $aftertax = $beforetax;
                }
                
                return {
                    original: parseFloat($original.toFixed(2), 10),
                    beforetax: parseFloat($beforetax.toFixed(2), 10), //稅前
                    aftertax: parseFloat($aftertax.toFixed(2), 10), //稅後
                    tax: parseFloat($tax.toFixed(2), 10), //稅
                }
            },
            btns: function(){
                let _type = this.type,
                    $result = []

                $result.push({
                    themes: 'warning',
                    icon: 'undo',
                    text: this.$t('site.func.shopnow'),
                    extendClass: 'is-large',
                    func: 'continueShopping',
                });

                if( this.checkFilter.length ) {
                    let _icon = '',
                        _text = '';

                    if( _type === 'hasprice' ) {
                        _icon = 'shopping_cart';
                        _text = 'page.shoppingcart.func.placeorder';
                    }else if( _type === 'noprice' ){
                        _icon = 'info';
                        _text = 'page.shoppingcart.func.begininquiry';
                    }

                    if( _text && _icon ) {

                        $result.push({
                            themes: 'send',
                            icon: _icon,
                            text: this.$t(_text),
                            extendClass: 'is-large is-hover',
                            func: 'order',
                        });
                    }
                }

                return $result;
            },
        },
        methods: {
            ...mapMutations([
                'pushPopUp',
                'pushNotification',
                'pushToolTip',
                'catchError',
                'changeShoppingCart',
                'isLoadingChange',
                'changeState',
                'setPriceObject',
                'initCredit',
                'setComment',
            ]),
            initAllowanceBar: function(){
                let $allowanceType = this.allowanceType || {},
                    $single = $allowanceType.single || {},
                    $total = $allowanceType.total || {}

                let $allowanceTable = this.allowanceTable || {},
                    $divTable = $allowanceTable[this.codiv] || {}

                let $result = {}

                let $_set = (type) => {
                        let $type = $divTable[type] || {},
                            $levelList = Object.keys($type); //[15000, 30000...]

                        $levelList = $levelList.map(item => parseInt(item, 10));

                        $levelList.sort((a, b) => a < b? -1: 1); //[200000, 100000...]

                        let _total = $total[type], //30000
                            _current = 0,
                            $range = []

                        $levelList.forEach((item, index) => {

                            if( _total >= item ) {
                                _current = index;
                            }

                            $range.push({
                                discount: $type[item],
                                qty: this.$okaTool.numberToStringFormat(item),
                            })
                        });

                        let _value = _current;

                        if( _value < $levelList.length - 1 ) {
                            _value += 1;
                        }

                        $result[type] = {
                            value: _value,
                            current: _current,
                            total: this.$okaTool.numberToStringFormat(_total),
                            range: $range,
                        }
                    }

                for( let _key in $single ) {
                    $_set(_key, $result);
                }

                this.$set(this, 'allowanceBar', $result);
            },
            changeClientByAutocomplete: function(){
                let _clientData = this.clientData,
                    $clientData = this.adcunoAddress.find(item => item.adcuno +' / '+ item.cufn === _clientData);

                if( $clientData ) {
                    this.changeClientCore($clientData.adcuno, $clientData.cufn, $clientData.dlsite);
                }else {
                    this.changeClientCore('', '', '');
                }
            },
            changeClientBySelect: function(){
                    
                if( this.clientData === '/' ) {
                    this.$set(this, 'clientData', '');

                    this.pushPopUp({
                        type: 'prompt',
                        content: {
                            caption: this.$t('page.shoppingcart.func.addCUNO'),
                            action: (val) => {
                                this.$siteTool.addCUNO(val, (data) => {

                                    if( !this.adcunoAddress.find(adcunoAddres => adcunoAddres.adcuno === data.adcuno) ) {
                                        this.adcunoAddress.push(data);
                                    }

                                    this.$set(this, 'clientData', data.adcuno +'@'+ data.cufn +'@'+ data.dlsite);
                                    this.changeClientCore(data.adcuno, data.cufn, data.dlsite);
                                });
                            }
                        }
                    });
                }else {
                    let _clientData = this.clientData || '@@',
                        $clientData = _clientData.split('@');

                    this.changeClientCore($clientData[0], $clientData[1], $clientData[2]);
                }
            },
            changeClientCore: function(adcuno, cufn, dlsite){
                this.$set(this.client, 'adcuno', adcuno);
                this.$set(this.client, 'cufn', cufn);
                this.$set(this.client, 'dlsite', dlsite);
            },
            updateDateSingle: function(sn, date) {
                this.$set(this.dateList, sn, date);
            },
            updatePriceSingle: function(sn) {
                let $list = this.list,
                    $target = $list.find(item => item.cart_sn === sn),
                    _price = this.getPriceSingle($target);
                    
                this.$set(this.priceList, sn, _price);
            },
            getPriceSingle: function(item){
                let $date = new Date();

                if( item.customer_need_date ) {
                    $date = new Date(item.customer_need_date);
                }

                let _date = $date.toLocaleDateString(),
                    _price = this.$siteTool.computedPrice(item, _date);

                return _price;
            },
            tagChange: function(sn, check){
                let $cartList = this.cartList,
                    _check = !check;

                if( sn === 'all' ){
                
                    $cartList.forEach(item =>{
                        item.check = _check;
                    });
                }else {
                    let $obj = $cartList.find(item => item.sn === sn), //勾選的項
                        $all = $cartList.find(item => item.sn === 'all'),
                        $filter = $cartList.filter(item => item.content); //除了 all

                    $obj.check = _check;

                    if( $filter.every(item => item.check === _check) ) { //如果每一個都一樣
                        $all.check = _check;
                    }else {
                        $all.check = false;
                    }
                }
            },
            showPopUp: function(evt, str){
                
                this.pushPopUp({
                    type: 'alert',
                    content: {
                        html: str
                    },
                })
            },
            showToolTip: function(evt, str){
                
                this.pushToolTip({
                    type: 'toolTip',
                    event: evt,
                    content: {
                        html: str
                    },
                    pointerEvents: 'none'
                })
            },
            validate:async function(callback) {
                let $list = this.checkFilter,
                    $month = []

                $list.forEach(_item =>{ //產品送達日期不可跨月
                    let _month = new Date(_item.content.customer_need_date).getMonth();

                    if( !$month.includes(_month) ) {
                        $month.push(_month)
                    }
                });

                if( $month.length > 1 ){

                    this.pushPopUp({
                        type: 'alert',
                        content: {
                            html: this.$t('popup.dday.func.alert'),
                        }
                    });
                }else if( this.editData ){

                    this.pushPopUp({
                        type: 'alert',
                        content: {
                            html: this.$t('popup.edit.func.alert'),
                        }
                    });
                }else{

                    try {
                        let $response = await Promise.all($list.map(item => this.$refs['mdCartInfo-'+ item.sn][0].validate())),
                            _result = $response.every(item => item);

                        if (_result){
                            callback();
                        }
                    }catch(error) {
                        console.log(error);
                    }
                }
            },
            continueShopping: function(){
                this.$router.push('/system/productList?class=1&product=all');
            },
            purchase: function(){
                let _filter = this.checkFilter,
                    $items = [],
                    text = '';

                _filter.forEach(data => {
                    let item = data.content;

                    $items.push({
                        item_id: item.cart_sn,
                        item_name: item.product_s,
                        item_brand: "Formosa Plastic Corporation",
                        item_category: item.product_b,
                        item_category2: item.product_m,
                        item_category3: item.product_s,
                        price: item.price,
                        quantity: item.qty
                    })
                })

                let date = new Date();
                text = this.user.cuno + '_' + date.toISOString();

                window.dataLayer = window.dataLayer || [];
                dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                dataLayer.push({
                    event: "purchase",
                    ecommerce: {
                        currency: "TWD",
                        value: this.info.beforetax,
                        transaction_id: text,
                        items: $items
                    }
                });
            },
            sendOrder: function(){
                let _type = 0, //1:下定 0:詢價
                    $filter = this.checkFilter,
                    $priceList = this.priceList;

                if( this.type === 'hasprice' ) {
                    _type = 1;
                }

                let $_core = async () => {

                        let _url = this.$siteTool.apiUrl({
                                class: 'ShoppingCart',
                                func: 'AddOrder',
                            }),
                            $condition = {
                                cart_price: $filter.map(item => {
                                    let $content = item.content,
                                        _sn = $content.cart_sn,
                                        _front_price = null;

                                    if( _type === 1 ) {
                                        _front_price = $priceList[_sn] //應該會有價格
                                    }

                                    return {
                                        cart_sn: _sn,
                                        front_price: _front_price,
                                    }
                                }),
                                type: _type,
                                adcuno: this.client.adcuno? this.client.adcuno: '',
                                cuodno: this.client.cuodno? this.client.cuodno: '',
                                remark: this.client.remark? this.client.remark: '',
                                dlsite: this.client.dlsite? this.client.dlsite: this.user.dlsite,
                            }

                        try {
                            let $inqtnoList = await this.$http.post(_url, $condition);

                            if( $inqtnoList && $inqtnoList.length ) { //打無人工審核

                                let _url = this.$siteTool.apiUrl({
                                        class: 'Order',
                                        func: 'CheckAgreement'
                                    });

                                for(let i = 0; i < $inqtnoList.length; i++){
                                    let $condition = {
                                            inqtno: $inqtnoList[i],
                                        }

                                    await this.$http.post(_url, $condition);
                                }
                            }

                            this.initCredit(); //重取授信

                            this.$set(this, 'clientData', ''); //以下更新摘要
                            this.$set(this, 'client', $defaultClient);

                            if( _type == 1 ){
                                this.purchase();
                            }
                            
                            let $_final = () => {

                                    $filter.forEach(item => {
                                        this.removeCartUI(item.content, false);
                                    });
                                    
                                    this.$emit('sendEvent', 'sendOrderDone', _type);
                                }

                            this.saveClient(() => {
                                let _comment = VueCookie.get('comment'),
                                    _showComment = false;

                                if( _comment ) {
                                    let $comment = new Date(_comment),
                                        $now = new Date();

                                    if($now > $comment) {
                                        _showComment = true;
                                    }
                                }

                                if( _showComment ) {
                    
                                    this.pushPopUp({
                                        type: 'starRate',
                                        content: {
                                            caption: this.$t('site.status.ordersuccess'),
                                            inqtno: $inqtnoList[0],
                                            callback: $_final,
                                        }
                                    });
                                }else {
                                    this.setComment();
                                    $_final();
                                }
                            });
                            
                        }catch(error) {

                            this.catchError({
                                error: error,
                                callback: $_core,
                            });
                        }
                    }

                this.initCredit(() => {
                    let _creditBalance = this.creditBalance,
                        _aftertax = this.info.aftertax;

                    if( _type && _creditBalance !== null && _aftertax > _creditBalance ) {

                        this.pushPopUp({
                            type: 'confirm',
                            content: {
                                html: this.$t('alert.exceededBalance'),
                                actionName: this.$t('page.shoppingcart.func.placeorder'),
                                action: $_core
                            }
                        });
                    }else {
                        $_core();
                    }
                });
            },
            order: function(){
                this.validate(this.sendOrder);
            },
            getProductAndSetPrice: async function(opt){
                let $target = this.$siteTool.getProduct(opt);

                if( $target ) {
                    let _sn = $target.product_sn,
                        _date = new Date(opt.customer_need_date).toLocaleDateString();

                    let $info = await this.$siteTool.getProductInfo({
                            sn: _sn,
                            date: _date,
                        }),
                        $detail = $info.detail || {},
                        _price = $detail.price || null;

                    this.setPriceObject({
                        sn: _sn,
                        date: _date,
                        price: _price,
                    });

                    return {
                        sn: _sn,
                        _price: _price,
                    }
                }else {
                    return {
                        sn: null,
                        _price: null,
                    }
                }
            },
            updateCart: async function(opt){ //更新價格、打紀錄 api
                let _cart_sn = opt.cart_sn,
                    _customer_need_date = opt.customer_need_date;

                let $dateList = this.dateList,
                    _saved_customer_need_date = $dateList[_cart_sn]
                
                let $_core = () => {
                        let $data = this.$siteTool.reInitShoppingCart({
                                customer_need_date: _customer_need_date
                            }),
                            _date = $data.customer_need_date;

                        let _url = this.$siteTool.apiUrl({
                                class: 'ShoppingCart',
                                func: 'Edit',
                            }),
                            $condition = {
                                cart_sn: _cart_sn,
                                package: opt.package_s,
                                quality: opt.quality,
                                outmfct: opt.outmfct,
                                customer_need_date: _date,
                                qty: opt.qty,
                            }

                        try {
                            this.$http.post(_url, $condition);
                        }catch(error) {
                            console.log(error);
                        }
                    }

                if( _customer_need_date === _saved_customer_need_date ) {
                    this.updatePriceSingle(_cart_sn);
                    $_core();
                }else {

                    try{
                        let $info = await this.getProductAndSetPrice(opt),
                            _sn = $info.sn;

                        if( _sn ) {
                            let __customer_need_date = new Date(_customer_need_date).toLocaleDateString(),
                                __saved_customer_need_date = new Date(_saved_customer_need_date).toLocaleDateString(),
                                $node = this.priceObject[_sn],
                                _price = $node[__customer_need_date],
                                _savedPrice = $node[__saved_customer_need_date] || null;
                            
                            if(typeof _price !== typeof _savedPrice){
                                let _alert = 'order.func.alert.orderToInquery';

                                if( typeof _price === 'number'){
                                    _alert = 'order.func.alert.inqueryToOrder';
                                }
                                
                                this.pushPopUp({
                                    type: 'confirm',
                                    content: {
                                        html: this.$t(_alert),
                                        actionName: this.$t('site.func.continue'),
                                        action: () =>{
                                            $_core();
                                            
                                            this.$emit('sendEvent', 'initShoppingCart'); //購物車使用，修改購物車列表
                                        },
                                        cancel: () => {
                                            opt.customer_need_date = _saved_customer_need_date;
                                            
                                            this.updatePriceSingle(_cart_sn);
                                        }
                                    }
                                });
                            }else{
                                this.updatePriceSingle(_cart_sn);
                                this.updateDateSingle(_cart_sn, _customer_need_date);
                                $_core();
                            }
                        }else {
                            console.log('找不到此產品');
                        }
                    }catch(error) {

                        this.catchError({
                            error: error,
                        });
                    }
                }
            },
            removeCartUI: function(opt, notification){

                this.changeShoppingCart({
                    func: 'remove',
                    data: opt,
                    notification: notification,
                });

                let $list = this.cartList,
                    $target = $list.find(item => item.sn === opt.cart_sn);

                if( $target ){
                    let _parentIndex = $list.indexOf($target)
                    
                    $list.splice(_parentIndex, 1)
                }

                delete this.priceList[opt.cart_sn]
                delete this.dateList[opt.cart_sn]
            },
            removeCartCore: async function(opt){
                let _url = this.$siteTool.apiUrl({
                        class: 'ShoppingCart',
                        func: 'Delete',
                    }),
                    $condition = {
                        cart_sn: opt.cart_sn
                    }

                try {
                    await this.$http.post(_url, $condition);

                    this.removeCartUI(opt, true);
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: () => {
                            this.removeCartCore(opt);
                        },
                    });
                }
            },
            removeCart: function(opt){

                this.pushPopUp({
                    type: 'confirm',
                    content: {
                        html: this.$t('page.shoppingcart.status.removeconfirm'),
                        actionName: this.$t('page.shoppingcart.caption.remove'),
                        action: () => {
                            this.removeCartCore(opt);
                        }
                    }
                });
            },
            saveClient: function(callback){
                let $_core = async () => {

                        let _url = this.$siteTool.apiUrl({
                                class: 'CartMaster',
                                func: 'Edit',
                            }),
                            $condition = this.client;

                        try {
                            await this.$http.post(_url, $condition);

                            this.$set(this, 'editData', false);

                            if( callback && typeof callback === 'function' ) {
                                callback();
                            }
                            
                        }catch(error) {

                            this.pushNotification({
                                type: 'notification',
                                content: {
                                    html: this.$siteConfig.publishError,
                                    status: 'danger'
                                }
                            });

                            this.$set(this, 'clientData', '');
                            this.$set(this, 'client', $defaultClient);
                        }
                    }

                this.$validator.validate().then(result => {

                    if (!result){
                        //啊就沒通過啊
                    }else {
                        $_core();
                    }
                });
            },
            editClient: function(){
                this.$set(this, 'editData', true);
            },
            // addClient: function(){
            //     let $sendAdd = async (opt) => {
            //             let _url = this.$siteTool.apiUrl({
            //                     class: 'CartMaster',
            //                     func: 'Edit',
            //                 });

            //             try {
            //                 let $response = await this.$http.post(_url, opt);

            //                 this.setClient($response);
                            
            //             }catch(error) {

            //                 this.catchError({
            //                     error: error,
            //                     callback: () => {
            //                         $sendAdd(opt);
            //                     }
            //                 });
            //             }
            //         }
                
            //     let $content = this.cartList.find(item => item.content),
            //         $codiv = $content.dsr_codiv;
                
            //     this.pushPopUp({
            //         type: 'addClient',
            //         content: {
            //             codiv: $codiv,
            //             action: (opt) => {
            //                 $sendAdd(opt);
            //             }
            //         }
            //     })
            // },
            // removeClient: function(){
            //     let $_core = async () => {
            //             let _url = this.$siteTool.apiUrl({
            //                     class: 'CartMaster',
            //                     func: 'Delete',
            //                 })

            //             try {
            //                 await this.$http.post(_url, {});

            //                 this.setClient({});
                            
            //             }catch(error) {

            //                 this.catchError({
            //                     error: error,
            //                     callback: $_core,
            //                 });
            //             }
            //         }

            //     this.pushPopUp({
            //         type: 'confirm',
            //         content: {
            //             html: this.$t('site.status.removeConfirm'),
            //             action: $_core
            //         }
            //     });
            // },
            initAdcunoAddress: async function(){

                try {
                    let $data = await this.getAdcunoAddress();

                    if( $data ){
                        let $client = this.client,
                            _adcuno = $client.adcuno,
                            _cufn = $client.cufn,
                            _dlsite = $client.dlsite;

                        if( _adcuno && _cufn && _dlsite ) {
                            let $target = $data.find(item => item.adcuno === _adcuno && item.cufn === _cufn && item.dlsite === _dlsite);

                            if( !$target ) {

                                $data.unshift({
                                    adcuno: _adcuno,
                                    codiv: '__',
                                    cufn: _cufn,
                                    dlsite: _dlsite,
                                })
                            }
                        }

                        this.$set(this, 'adcunoAddress', $data);
                    }
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.initAdcunoAddress,
                    });
                }
            },
            getAdcunoAddress: function(){
                let $content = this.list[0] || {},
                    _codiv = $content.dsr_codiv;

                let _url = this.$siteTool.apiUrl({
                        class: 'AdcunoAddress',
                        func: 'List',
                    }),
                    $condiction = {
                        codiv: _codiv
                    }

                return this.$http.post(_url, $condiction);
            },
            // initAdcunoAddress: async function(){

            //     try {
            //         let $data = await this.getAdcunoAddress();

            //         this.$set(this, 'adcunoAddress', $data);
                    
            //     }catch(error) {

            //         this.catchError({
            //             error: error,
            //             callback: this.init,
            //         });
            //     }
            // },
            getClient: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'CartMaster',
                        func: 'Info',
                    });

                return this.$http.post(_url, {});
            },
            initClient: async function(){

                try {
                    let $data = await this.getClient();

                    if( $data ){

                        for( let _key in $defaultClient ) {

                            if( !$data[_key] ) {
                                $data[_key] = $defaultClient[_key]
                            }
                        }

                        if( $data.adcuno && $data.cufn && $data.dlsite ) {
                            this.$set(this, 'clientData', $data.adcuno +'@'+ $data.cufn +'@'+ $data.dlsite);
                        }

                        this.$set(this, 'client', $data);
                    }else {
                        this.$set(this, 'clientData', '');
                        this.$set(this, 'client', $defaultClient);
                    }

                    this.initAdcunoAddress();
                    
                }catch(error) {

                    this.catchError({
                        error: error,
                        callback: this.initClient,
                    });
                }
            },
            initList: function(){
                let $list = this.list,
                    $priceList = {},
                    $dateList = {}

                $list.forEach(item => {
                    $priceList[item.cart_sn] = this.getPriceSingle(item);
                    $dateList[item.cart_sn] = item.customer_need_date;
                });

                this.$set(this, 'priceList', $priceList);
                this.$set(this, 'dateList', $dateList);
            },
            initCart: function(){
                let $list = this.list,
                    $result = []
                
                let _defaultCheck = true;

                let _orderSn = VueCookie.get('orderSn') || 0;

                if( this.type === 'unmarket' || _orderSn ) { //如果是不在 market 或是 立即下單，就預設不打勾
                    _defaultCheck = false;
                }

                $result.push({ //加入全選設定
                    check: _defaultCheck,
                    sn: 'all',
                    content: null,
                });

                $list.forEach(item => { //加入品別項目

                    $result.push({ 
                        check: _defaultCheck,
                        sn: item.cart_sn,
                        content: item,
                    });
                });

                if( _orderSn ) {
                    let $target = $result.find(item => item.sn == _orderSn);

                    if( $target ) {
                        $target.check = true;
                    }
                    
                    VueCookie.delete('orderSn');
                }
                
                this.$set(this, 'cartList', $result);
            },
            getDiscount: function(){
                let _url = this.$siteTool.apiUrl({
                        class: 'Discount',
                    });

                return this.$http.post(_url, {
                    dDate: this.checkMonth +'-01',
                });
            },
            initDiscount: async function(){

                if( this.type === 'hasprice' && this.checkMonth ) {

                    try {
                        let $data = await this.getDiscount();

                        this.$set(this, 'discountData', $data);
                    }catch(error) {

                        this.catchError({
                            error: error,
                            callback: this.initDiscount,
                        });
                    }
                }else {
                    this.$set(this, 'discountData', []);
                }
            },
        },
        created: function(){
            this.initCart();
            this.initList();
            this.initClient();
        }
    }
</script>

<style scoped lang="scss">

    .cp.input.textarea {
        margin: $interval-m $interval-m 0;
        display: block;

        textarea {
            width: 100%;
            height: 120px;
        }
    }

    .list{

        .checkbox{
            align-self: center;
            margin-right: $interval-m;
        }

        .group {
            background-color: $white;
            padding: $interval-m;
            border-radius: $border-radius;
            // box-shadow: $box-shadow;
            border: $border;

            + .group {
                margin-top: $interval-s;
                padding-top: $interval-l;
                padding-bottom: $interval-xl;
            }
        }
    }

    .extend {
        $type: map-get($colors, 'danger');
        $text: map-get($type, 'text');

        color: $text;
        font-size: $font-size-s;
        margin-left: $interval-m;

        &::before {
            $type: map-get($colors, 'danger');
            $text: map-get($type, 'text');

            @extend %font-pseudo;
            vertical-align: middle;
            margin-right: $interval-s;
            position: relative;
            margin-right: $interval-xs;
            content: '\e000';
            color: $text;
        }
    }

    .slidecheck {
        display: none;

        + label  {
            display: block;
            position: relative;
            font-size: 16px;
            line-height: 20px; //將 label 的高設為 20px
            padding-left: 50px; //避開勾選框

            &::before { //勾選框的底
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 40px;
                height: 20px;
                background-color: $gray;
                border-radius: $border-radius;
            }

            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 18px; //製作一個 20px * 20px 的開關
                height: 18px;
                border-width: 1px;
                border-style: solid;
                border-color: $gray;
                background-color: #fff;
                border-radius: $border-radius;
                transition: left 0.2s;
            }
        }

        &:checked {

            + label {

                &::before {
                    background-color: $major-color;
                    border-radius: $border-radius;
                }

                &::after {
                    border-color:  $major-color;
                    left: 20px; //開關往左移動 20px
                    border-radius: $border-radius;
                }
            }
        }
    }

    .color {
        margin: 0 $interval-m;
    }
</style>
